import dayjs, { Dayjs } from "utils/dayjs"
import { Guid } from "@/types"
import { getTranslation } from "utils/translations"
import { InvoicePositionUnit } from "./InvoicePositionBase"
import TenantInvoicePosition, { InvoicePositionType } from "./TenantInvoicePosition"

export interface IGetInvoiceDraftInvoicePositionDto {
    reservationInvoicePositionId: Guid
    parentId?: Guid | null
    type: InvoicePositionType
    number: string
    text?: string | null
    amount: number
    unit: InvoicePositionUnit
    unitPrice: number
    unitQuantity?: number | null
    start: string
    end?: string | null
}

export default class InvoiceDraftInvoicePosition {
    reservationInvoicePositionId: Guid
    type: InvoicePositionType
    number: string
    #text?: string
    amount: number
    unit: InvoicePositionUnit
    unitPrice: number
    unitQuantity?: number
    start: Dayjs
    end?: Dayjs

    // hydrated separetely
    invoicePosition?: TenantInvoicePosition

    constructor(dto: IGetInvoiceDraftInvoicePositionDto) {
        this.reservationInvoicePositionId = dto.reservationInvoicePositionId
        this.type = dto.type
        this.number = dto.number
        this.#text = dto.text || undefined
        this.amount = dto.amount
        this.unit = dto.unit
        this.unitPrice = dto.unitPrice
        this.unitQuantity = dto.unitQuantity ?? undefined
        this.start = dayjs.utc(dto.start, "YYYY-MM-DD")
        this.end = dto.end ? dayjs.utc(dto.end, "YYYY-MM-DD") : undefined
    }

    get isHydrated() {
        return !!this.invoicePosition
    }

    get description(): string {
        return getTranslation(this.invoicePosition?.description)
    }

    get text(): string {
        return this.#text || getTranslation(this.invoicePosition?.text)
    }
}
